import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext({ content: null, t: () => "", refresh: () => {} });

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);

    const load = useCallback(() => {
        return api
            .get("/content")
            .then((r) => setContent(r.data))
            .catch(() => setContent({}));
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const t = useCallback(
        (key, fallback = "") => {
            if (content && content[key] !== undefined && content[key] !== null) return content[key];
            return fallback;
        },
        [content],
    );

    return <ContentCtx.Provider value={{ content, t, refresh: load }}>{children}</ContentCtx.Provider>;
};

export const useContent = () => useContext(ContentCtx);
